// extracted by mini-css-extract-plugin
var _1 = "rlNjiGyuvmVsMfQ2dGp9";
var _2 = "BRz4QfDg6qz2nztQm8Gl";
var _3 = "M2BMS3vamKI19xladGdl";
var _4 = "Q_jzZEoV3HQ3CCzfmJdk";
export { _1 as "actualSize", _2 as "customSize", _3 as "hasClick", _4 as "materialSymbol" }
